import type { LucideIcon } from 'lucide-react';
import { StatusPill, type StatusPillVariant } from '@/components/ui/status-pill';
import { cn } from '@/lib/utils';

interface ShareTabHeaderProps {
  icon: LucideIcon;
  title: string;
  /** Who the tab reaches, e.g. "Public · No sign-in". */
  audience: string;
  tone: Extract<StatusPillVariant, 'info' | 'muted'>;
}

const TILE_CLASSES: Record<ShareTabHeaderProps['tone'], string> = {
  info: 'bg-info-soft text-info-soft-foreground',
  muted: 'bg-secondary text-secondary-foreground'
};

/** A Share modal tab's opening line: an icon tile, what it does, and who it reaches. */
const ShareTabHeader = ({ icon: Icon, title, audience, tone }: ShareTabHeaderProps) => (
  <div className="flex items-start gap-3">
    <span
      aria-hidden
      className={cn(
        'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg',
        TILE_CLASSES[tone]
      )}
    >
      <Icon className="h-[18px] w-[18px]" />
    </span>
    <div className="flex min-h-9 min-w-0 flex-1 flex-wrap items-center gap-2">
      <span className="text-sm font-semibold">{title}</span>
      <StatusPill variant={tone} icon={Icon}>
        {audience}
      </StatusPill>
    </div>
  </div>
);

export default ShareTabHeader;
